/* Kalemsy deneme masası. Bölüm: sections/kls-deneme-masasi.liquid, görünüm /?view=kls-deneme (Rehberler). */
(function () {
  if (window.KLSDM) return;

  var S = 8; /* büyütülmüş görünüm: 1 mm = 8 piksel */
  var NS = 'http://www.w3.org/2000/svg';
  var SVGT = { svg: 1, g: 1, path: 1, rect: 1, circle: 1, line: 1, text: 1, polygon: 1, polyline: 1 };
  /* JIS S 6005:2019 Tablo 6, uç çapı aralığı; çizgi aralığın ortasıyla çizilir */
  var UCLAR = [
    { mm: 0.2, jis: '0,27-0,29', w: 0.28 },
    { mm: 0.3, jis: '0,37-0,39', w: 0.38 },
    { mm: 0.5, jis: '0,55-0,58', w: 0.565 },
    { mm: 0.7, jis: '0,69-0,73', w: 0.71 },
    { mm: 0.9, jis: '0,88-0,92', w: 0.9 }
  ];
  var PARA = { g: 8.2, d: 26.15 }; /* 1 TL, 2009-2022 basımı; çap 2023 sonrasıyla aynı */
  var NOTLAR = {
    kt: [
      'Kuru Toga motoru üç dişliden oluşur. Yazarken bastırma kuvvetiyle ortadaki dişli iner kalkar; her çizgide uç biraz döner (Mitsubishi Pencil).',
      'Standart motor ucu 40 çizgide bir tam tur döndürür. Çizgi başına 9 derece buradan hesaplandı; resmi kaynak dereceyi yazmıyor.',
      'Dönüşün amacı ucun her yanının eşit aşınması. Alttaki iki uç bunun şeması, ölçü değil.'
    ],
    kt2: [
      'Kuru Toga motoru üç dişliden oluşur. Yazarken bastırma kuvvetiyle ortadaki dişli iner kalkar; her çizgide uç biraz döner (Mitsubishi Pencil).',
      'Bu kalemdeki W hız motoru standart motorun iki katı hızla döner: 20 çizgide bir tam tur. Çizgi başına 18 derece buradan hesaplandı.',
      'Dönüşün amacı ucun her yanının eşit aşınması. Alttaki iki uç bunun şeması, ölçü değil.'
    ],
    orenz: [
      'Orenz ucu borudan dışarı çıkarmadan yazar; uç borunun içinde korunur (Pentel).',
      'Uç aşındıkça boru da onunla birlikte geri kayar, yazı kesilmeden devam eder (Pentel).'
    ],
    nero: [
      'Nero\'da boru aynı biçimde kayar; ayrıca kalem kâğıttan her kalkışta uç kendiliğinden ilerler (Pentel).',
      'İlk basıştan sonra kalan uç kısalana kadar basmadan yazılabilir (Pentel).'
    ],
    shaker: [
      'Sallama mekanizmasını Pilot 1978\'de geliştirdi (Pilot).',
      'Kalem yukarı savrulunca içteki ağırlık arkaya, klips yönüne gider; aşağı inerken mandala vurur ve uç bir adım ilerler. Üst düğmeye basmakla aynı iş (Pilot).',
      'Ağırlığın yeri katalog fotoğrafından ölçüldü: alt ve üst gövdenin birleşim yerinde durur.'
    ]
  };
  var RENK = { ink: '#090302', line: '#7d878c', mark: '#fac8cd', graphite: '#2e2f33', hi: '#c8102e', gridc: '#dde7ef', muted: '#5f676b' };

  /* sitenin gövde yazı tipi (Muli); tuval ve şema yazıları da bununla */
  function govdeYazi() { try { return getComputedStyle(document.body).fontFamily || 'sans-serif'; } catch (e) { return 'sans-serif'; } }
  function tr(n, d) { var v = d == null ? Math.round(n * 100) / 100 : Number(n).toFixed(d); return String(v).replace('.', ','); }
  function h(tag, props) {
    var el = SVGT[tag] ? document.createElementNS(NS, tag) : document.createElement(tag);
    props = props || {};
    Object.keys(props).forEach(function (k) {
      var v = props[k]; if (v == null || v === false) return;
      if (k === 'on') { Object.keys(v).forEach(function (e) { el.addEventListener(e, v[e]); }); }
      else el.setAttribute(k, v === true ? '' : v);
    });
    for (var i = 2; i < arguments.length; i++) ekle(el, arguments[i]);
    return el;
  }
  function ekle(el, k) {
    if (k == null) return;
    if (Array.isArray(k)) { k.forEach(function (x) { ekle(el, x); }); return; }
    el.appendChild(k.nodeType ? k : document.createTextNode(String(k)));
  }
  function bosalt(el) { while (el.firstChild) el.removeChild(el.firstChild); }
  function oku(k, v) { try { var x = localStorage.getItem(k); return x == null ? v : x; } catch (e) { return v; } }
  function yaz(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }

  /* arayüz tıkı: kalemin kaydı değil */
  var ses = { on: oku('kls-dm-ses', '1') === '1', ctx: null };
  function tik(p) {
    if (ses.on) {
      try {
        ses.ctx = ses.ctx || new (window.AudioContext || window.webkitAudioContext)();
        var c = ses.ctx; if (c.state === 'suspended') c.resume();
        var len = Math.floor(c.sampleRate * 0.026), b = c.createBuffer(1, len, c.sampleRate), d = b.getChannelData(0);
        for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 5);
        var s = c.createBufferSource(); s.buffer = b;
        var f = c.createBiquadFilter(); f.type = 'bandpass'; f.frequency.value = 2900 * (p || 1); f.Q.value = 1.4;
        var g = c.createGain(); g.gain.value = 0.45;
        s.connect(f); f.connect(g); g.connect(c.destination); s.start();
      } catch (e) {}
    }
    try { if (navigator.vibrate) navigator.vibrate(6); } catch (e) {}
  }

  /* grafit dokusu: kâğıt pürüzü gibi duran sabit bir gren deseni (benzetim) */
  function gren(ctx) {
    if (ctx._gren) return ctx._gren;
    var N = 96, c = document.createElement('canvas'); c.width = c.height = N;
    var g = c.getContext('2d'), im = g.createImageData(N, N), seed = 11;
    function rnd() { seed = (seed * 16807) % 2147483647; return seed / 2147483647; }
    for (var i = 0; i < N * N; i++) {
      var r = rnd(), a = r < 0.11 ? 0.18 + rnd() * 0.3 : 0.62 + rnd() * 0.33, v = 46 + Math.floor(rnd() * 26);
      im.data[i * 4] = v; im.data[i * 4 + 1] = v; im.data[i * 4 + 2] = v + 5; im.data[i * 4 + 3] = Math.round(a * 255);
    }
    g.putImageData(im, 0, 0); ctx._gren = ctx.createPattern(c, 'repeat');
    try { var dd = ctx.getTransform().a || 1; ctx._gren.setTransform(new DOMMatrix().scale(1 / dd)); } catch (e) {}
    return ctx._gren;
  }
  function gCiz(ctx) { ctx.strokeStyle = 'rgba(58,60,64,.42)'; ctx.stroke(); ctx.strokeStyle = gren(ctx); ctx.stroke(); }
  function gozle(el, f) { if (window.ResizeObserver) new ResizeObserver(f).observe(el); else window.addEventListener('resize', f); }

  /* ---------- kâğıt ---------- */
  function Kagit(host, o) {
    var wrap = h('div', { 'class': 'kdm-kagit' });
    var cv = h('canvas', { role: 'img', 'aria-label': 'Deneme kâğıdı: parmağınızla ya da fareyle çizin' });
    var sil = h('button', { 'class': 'kdm-sil', type: 'button' }, 'sil');
    wrap.appendChild(cv); wrap.appendChild(sil); host.appendChild(wrap);
    var ctx = cv.getContext('2d'), H = o.height || 212, W = 0, mm = o.mm, onceki = null, cur = null, cizgiler = [];
    function sc() { return o.olcek(); }
    function uzun(s) { var L = 0; for (var i = 1; i < s.p.length; i++) L += Math.hypot(s.p[i][0] - s.p[i - 1][0], s.p[i][1] - s.p[i - 1][1]); return L; }
    function sigdir() {
      var w = wrap.clientWidth; if (!w) return; W = w; var dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx._gren = null; ciz();
    }
    gozle(wrap, sigdir);
    function ln(x1, y1, x2, y2, c, w) { ctx.strokeStyle = c; ctx.lineWidth = w; ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke(); }
    function halka(x0, y0, d, r, len, w, col) {
      ctx.lineWidth = w; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.beginPath();
      var tEnd = len / r, ilk = true;
      for (var t = 0; t <= tEnd; t += 0.05) { var x = x0 + r * t - d * Math.sin(t), y = y0 + d * Math.cos(t) * 0.9; if (ilk) { ctx.moveTo(x, y); ilk = false; } else ctx.lineTo(x, y); }
      if (col) { ctx.strokeStyle = col; ctx.stroke(); } else gCiz(ctx);
    }
    function cetvel() {
      var k = sc(), y = H - 20.5, x0 = 12.5, n = Math.min(40, Math.floor((W - 48) / k));
      ctx.lineCap = 'butt'; ln(x0, y, x0 + n * k, y, RENK.ink, 1);
      for (var i = 0; i <= n; i++) { var t = i % 10 === 0 ? 9 : i % 5 === 0 ? 6 : 3; ln(x0 + i * k, y, x0 + i * k, y - t, RENK.ink, 1); }
      ctx.fillStyle = RENK.ink; ctx.font = '400 12px ' + govdeYazi(); ctx.textBaseline = 'top'; ctx.textAlign = 'center';
      for (var j = 0; j <= n; j += 10) ctx.fillText(String(j), x0 + j * k, y + 4);
      ctx.textAlign = 'left'; ctx.fillText('mm', x0 + n * k + 6, y - 6);
    }
    function ciz() {
      if (!W) return; ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H); ctx.lineCap = 'butt';
      var k5 = 5 * sc();
      for (var x = 20.5; x < W; x += k5) ln(x, 0, x, H, RENK.gridc, 1);
      for (var y = 16.5; y < H; y += k5) ln(0, y, W, y, RENK.gridc, 1);
      if (onceki != null && onceki !== mm) halka(30, H / 2 - 22, 18, 5.6, W - 80, onceki * sc(), 'rgba(120,128,134,.32)');
      halka(30, H / 2 - 22, 18, 5.6, W - 80, mm * sc());
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      cizgiler.forEach(function (s) {
        ctx.lineWidth = s.mm * sc(); ctx.beginPath();
        s.p.forEach(function (q, i) { if (i) ctx.lineTo(q[0], q[1]); else ctx.moveTo(q[0], q[1]); });
        if (s.p.length === 1) ctx.lineTo(s.p[0][0] + 0.01, s.p[0][1]);
        gCiz(ctx);
      });
      cetvel();
      if (!cizgiler.length) { ctx.fillStyle = '#7d868b'; ctx.font = '400 13px ' + govdeYazi(); ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('İlk çizgiyi siz çekin.', W / 2, H - 48); ctx.textAlign = 'left'; }
      var top = cizgiler.reduce(function (a, s) { return a + uzun(s); }, 0) / sc();
      ctx.fillStyle = RENK.muted; ctx.font = '400 12px ' + govdeYazi(); ctx.textBaseline = 'top'; ctx.textAlign = 'left';
      ctx.fillText(cizgiler.length + ' çizgi · ' + Math.round(top) + ' mm', 10, 9);
    }
    function nokta(e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
    cv.addEventListener('pointerdown', function (e) { cur = { mm: mm, p: [nokta(e)] }; cizgiler.push(cur); cv.setPointerCapture(e.pointerId); ciz(); });
    cv.addEventListener('pointermove', function (e) { if (!cur) return; cur.p.push(nokta(e)); ciz(); });
    function bitir() { cur = null; }
    cv.addEventListener('pointerup', bitir); cv.addEventListener('pointercancel', bitir);
    sil.addEventListener('click', function () { cizgiler.length = 0; ciz(); });
    return { set: function (m) { if (m !== mm) onceki = mm; mm = m; ciz(); }, ciz: ciz };
  }

  /* kalınlıklar tek sırada, her biri kendi etiketinin üstünde */
  function Sira(host, o) {
    var wrap = h('div', { 'class': 'kdm-sira' });
    var cv = h('canvas', { role: 'img', 'aria-label': 'Uç kalınlıkları yan yana, aynı ölçekte' });
    wrap.appendChild(cv); host.appendChild(wrap); var ctx = cv.getContext('2d');
    function ciz() {
      var W = cv.clientWidth; if (!W) return; var dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = Math.round(W * dpr); cv.height = Math.round(30 * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx._gren = null; ctx.clearRect(0, 0, W, 30);
      var ic = W - 60, n = o.w.length, seg = Math.min(48, ic / (n - 1) * 0.74); ctx.lineCap = 'butt';
      o.w.forEach(function (w, i) { var cx = 30 + ic * i / (n - 1); ctx.lineWidth = w * o.olcek(); ctx.beginPath(); ctx.moveTo(cx - seg / 2, 16); ctx.lineTo(cx + seg / 2, 16); gCiz(ctx); });
    }
    gozle(wrap, ciz);
    return { ciz: ciz };
  }

  /* kapsül kaydırıcı */
  function Kapsul(host, o) {
    var rail = h('div', { 'class': 'kdm-ray' }); rail.appendChild(h('div', { 'class': 'kdm-ray-cizgi' }));
    (o.olcek || []).forEach(function (s) {
      rail.appendChild(h('div', { 'class': 'kdm-ray-cent kdm-ray-cent--ince', style: 'left:' + s.pos * 100 + '%' }));
      if (s.label) rail.appendChild(h('div', { 'class': 'kdm-ray-etiket', style: 'left:' + s.pos * 100 + '%' }, s.label));
    });
    var etiketler = o.duraklar.map(function (s) {
      rail.appendChild(h('div', { 'class': 'kdm-ray-cent', style: 'left:' + s.pos * 100 + '%' }));
      if (o.etiket === false) return null;
      var l = h('div', { 'class': 'kdm-ray-etiket', style: 'left:' + s.pos * 100 + '%' }, s.label); rail.appendChild(l); return l;
    });
    var dugme = h('div', { 'class': 'kdm-kapsul', role: 'slider', tabindex: '0', 'aria-label': o.aria, 'aria-valuemin': '0', 'aria-valuemax': String(o.duraklar.length - 1) }, h('i', { 'class': 'k1' }), h('i', { 'class': 'k2' }), h('i', { 'class': 'k3' }));
    var igneEl = null;
    if (o.igne) { rail.classList.add('kdm-ray--igne'); igneEl = h('div', { 'class': 'kdm-ray-igne', style: 'left:' + o.igne.pos * 100 + '%' }, o.igne.label); rail.appendChild(igneEl); }
    var bal = h('div', { 'class': 'kdm-balon', 'aria-hidden': 'true' });
    rail.appendChild(dugme); rail.appendChild(bal); host.appendChild(rail);
    var cur = -1, drag = false;
    function set(i, sessiz) {
      i = Math.max(0, Math.min(o.duraklar.length - 1, i)); var ch = i !== cur; cur = i;
      dugme.style.left = o.duraklar[i].pos * 100 + '%'; dugme.setAttribute('aria-valuenow', String(i)); dugme.setAttribute('aria-valuetext', o.duraklar[i].label);
      etiketler.forEach(function (l, j) { if (l) l.classList.toggle('on', j === i); });
      bal.textContent = o.duraklar[i].balon || o.duraklar[i].label; if (!drag) bal.style.left = o.duraklar[i].pos * 100 + '%';
      if (ch && !sessiz) tik(); if (ch) o.degisti(i);
    }
    function yakin(x) { var r = rail.getBoundingClientRect(), p = (x - r.left) / r.width, b = 0; o.duraklar.forEach(function (s, i) { if (Math.abs(s.pos - p) < Math.abs(o.duraklar[b].pos - p)) b = i; }); return b; }
    function tasi(e) { var r = rail.getBoundingClientRect(), p = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)); set(yakin(e.clientX)); dugme.style.left = p * 100 + '%'; bal.style.left = p * 100 + '%'; }
    rail.addEventListener('pointerdown', function (e) { drag = true; rail.classList.add('surukle'); rail.setPointerCapture(e.pointerId); dugme.style.transition = 'none'; tasi(e); });
    rail.addEventListener('pointermove', function (e) { if (drag) tasi(e); });
    function son() { if (!drag) return; drag = false; rail.classList.remove('surukle'); dugme.style.transition = ''; dugme.style.left = o.duraklar[cur].pos * 100 + '%'; bal.style.left = o.duraklar[cur].pos * 100 + '%'; }
    rail.addEventListener('pointerup', son); rail.addEventListener('pointercancel', son);
    dugme.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { set(cur + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { set(cur - 1); e.preventDefault(); }
    });
    set(o.deger || 0, true);
    return { set: set, get: function () { return cur; }, igne: function (pos) { if (igneEl) igneEl.style.left = pos * 100 + '%'; } };
  }

  /* ---------- mekanizma şemaları ---------- */
  function yazi(x, y, s, o) { o = o || {}; return h('text', { x: x, y: y, 'font-size': o.size || 11, 'font-family': govdeYazi(), fill: o.fill || RENK.ink, 'text-anchor': o.anchor || 'start', 'font-weight': o.weight && o.weight >= 500 ? 700 : 400, 'font-variant-numeric': 'tabular-nums' }, s); }
  function kutup(cx, cy, r, deg) { var a = deg * Math.PI / 180; return [cx + r * Math.sin(a), cy - r * Math.cos(a)]; }
  function ara(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }
  function notlar(list) { return h('ul', { 'class': 'kdm-notlar' }, (list || []).map(function (t, i) { return h('li', null, h('b', null, String(i + 1)), h('span', null, t)); })); }
  function dugmeSatiri() { var r = h('div', { 'class': 'kdm-dugmeler' }); for (var i = 0; i < arguments.length; i++) r.appendChild(arguments[i]); return r; }
  function dugme(ad, f) { return h('button', { 'class': 'kdm-btn', type: 'button', on: { click: f } }, ad); }

  function mekKT(st, tur) {
    var full = tur === 'kt2' ? 20 : 40, deg = 360 / full;
    var svg = h('svg', { viewBox: '0 0 320 244', 'class': 'kdm-sema', role: 'img', 'aria-label': 'Kuru Toga şeması: uç her çizgide ' + tr(deg) + ' derece döner' });
    svg.appendChild(h('rect', { x: 8, y: 8, width: 146, height: 112, rx: 3, fill: '#ffffff', stroke: RENK.line, 'stroke-width': 1 }));
    var cizgiler = h('g'); svg.appendChild(cizgiler);
    var cx = 238, cy = 60, r = 40, a1 = kutup(cx, cy, r, -16), a2 = kutup(cx, cy, r, 16);
    var don = h('g', { 'class': 'kdm-don', style: 'transform-origin:' + cx + 'px ' + cy + 'px' });
    don.appendChild(h('circle', { cx: cx, cy: cy, r: r, fill: RENK.graphite }));
    don.appendChild(h('path', { d: 'M' + cx + ' ' + cy + ' L' + a1[0] + ' ' + a1[1] + ' A' + r + ' ' + r + ' 0 0 1 ' + a2[0] + ' ' + a2[1] + ' Z', fill: RENK.mark }));
    svg.appendChild(don);
    svg.appendChild(h('path', { d: 'M' + (cx - 7) + ' ' + (cy + r + 8) + ' L' + (cx + 7) + ' ' + (cy + r + 8) + ' L' + cx + ' ' + (cy + r + 16) + ' Z', fill: RENK.ink }));
    svg.appendChild(yazi(cx, cy + r + 30, 'uç, alttan görünüş', { anchor: 'middle' }));
    var say = yazi(81, 140, '', { anchor: 'middle', size: 13, weight: 500 }), say2 = yazi(81, 157, '', { anchor: 'middle', fill: RENK.muted }), ipucu = yazi(81, 68, 'buraya çizgi çekin', { anchor: 'middle', fill: '#7d868b' });
    svg.appendChild(say); svg.appendChild(say2); svg.appendChild(ipucu);
    var tipY = 158;
    function uc(x, ad) { var p = h('polygon', { fill: RENK.graphite }), f = h('line', { stroke: RENK.hi, 'stroke-width': 2, 'stroke-linecap': 'round' }); svg.appendChild(p); svg.appendChild(f); svg.appendChild(yazi(x, 238, ad, { anchor: 'middle' })); return { x: x, p: p, f: f }; }
    var t1 = uc(196, 'dönmeyen uç'), t2 = uc(278, 'Kuru Toga');
    function bicim(t, asin, egik) {
      var x = t.x, sh = tipY + 36, pt = [x, tipY + 58], L = [x - 9, sh], R = [x + 9, sh];
      var A = ara(pt, L, asin * (egik ? 0.95 : 0.22)), B = ara(pt, R, asin * 0.22);
      t.p.setAttribute('points', [[x - 9, tipY], [x + 9, tipY], R, B, A, L].map(function (q) { return q.join(','); }).join(' '));
      t.f.setAttribute('x1', A[0]); t.f.setAttribute('y1', A[1]); t.f.setAttribute('x2', B[0]); t.f.setAttribute('y2', B[1]); t.f.style.opacity = asin > 0.05 ? 1 : 0;
    }
    var n = 0;
    function goster() {
      var w = Math.min(1, n / 24); bicim(t1, w, true); bicim(t2, w, false); don.style.transform = 'rotate(' + n * deg + 'deg)';
      say.textContent = n + ' çizgi · ' + Math.round((n * deg) % 360) + '°';
      say2.textContent = n && n % full === 0 ? 'tam tur döndü' : 'tam tura ' + (full - (n % full)) + ' çizgi'; ipucu.style.opacity = n ? 0 : 1;
    }
    function say1() { n++; goster(); tik(1.6); }
    function hazir() { var i = n % 18, x = 18 + (i % 3) * 44, y = 22 + Math.floor(i / 3) * 16; if (i === 0) bosalt(cizgiler); cizgiler.appendChild(h('line', { x1: x, y1: y, x2: x + 36, y2: y, stroke: 'rgba(46,47,51,.9)', 'stroke-width': 2.4, 'stroke-linecap': 'round' })); say1(); }
    var alan = h('div', { 'class': 'kdm-alan', 'aria-hidden': 'true' });
    var kap = h('div', { 'class': 'kdm-sema-kap' }, svg, alan);
    function svgNokta(e) { var r = svg.getBoundingClientRect(), k = 320 / r.width; return [Math.max(12, Math.min(150, (e.clientX - r.left) * k)), Math.max(12, Math.min(116, (e.clientY - r.top) * k))]; }
    var pl = null, pts = [];
    alan.addEventListener('pointerdown', function (e) { pts = [svgNokta(e)]; pl = h('polyline', { points: pts[0].join(','), fill: 'none', stroke: 'rgba(46,47,51,.9)', 'stroke-width': 2.4, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }); cizgiler.appendChild(pl); alan.setPointerCapture(e.pointerId); e.preventDefault(); });
    alan.addEventListener('pointermove', function (e) { if (!pl) return; pts.push(svgNokta(e)); pl.setAttribute('points', pts.map(function (q) { return q.join(','); }).join(' ')); });
    function kalk() { if (!pl) return; var L = 0; for (var i = 1; i < pts.length; i++) L += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]); if (L < 8) pl.parentNode.removeChild(pl); else { while (cizgiler.childNodes.length > 14) cizgiler.removeChild(cizgiler.firstChild); say1(); } pl = null; }
    alan.addEventListener('pointerup', kalk); alan.addEventListener('pointercancel', kalk);
    goster();
    st.appendChild(kap);
    st.appendChild(dugmeSatiri(dugme('Çizgi çek', hazir), dugme('Baştan', function () { n = 0; bosalt(cizgiler); goster(); })));
    st.appendChild(notlar(NOTLAR[tur]));
  }

  function mekOrenz(st, nero) {
    var svg = h('svg', { viewBox: '0 0 320 222', 'class': 'kdm-sema', role: 'img', 'aria-label': 'Orenz şeması: uç borunun içinde kalır, yazdıkça boru geri kayar' });
    var kY = 176, P0 = 92, adim = 13, MAX = 5;
    svg.appendChild(h('line', { x1: 20, y1: kY + 0.5, x2: 300, y2: kY + 0.5, stroke: RENK.line, 'stroke-width': 1 }));
    var yazilan = h('g'); svg.appendChild(yazilan);
    var koni = h('polygon', { fill: '#e9ecee', stroke: RENK.line, 'stroke-width': 1 }), boru = h('rect', { x: 154, width: 12, fill: '#c9cfd2', stroke: RENK.line, 'stroke-width': 1 }), uc = h('rect', { x: 157.5, width: 5, fill: RENK.graphite });
    svg.appendChild(koni); svg.appendChild(boru); svg.appendChild(uc);
    var olcu = h('g'); svg.appendChild(olcu);
    var say = yazi(18, 22, '', { size: 13, weight: 500 }), msj = yazi(18, 212, ''); svg.appendChild(say); svg.appendChild(msj);
    var n = 0, wc = 0, mesgul = false, oto = false;
    function goster() {
      var len = P0 - n * adim, top = kY - len;
      koni.setAttribute('points', '120,' + (top - 64) + ' 200,' + (top - 64) + ' 176,' + top + ' 144,' + top);
      boru.setAttribute('y', top); boru.setAttribute('height', len); uc.setAttribute('y', top - 30); uc.setAttribute('height', len + 30);
      bosalt(olcu);
      olcu.appendChild(h('line', { x1: 184, y1: top, x2: 184, y2: kY, stroke: RENK.hi, 'stroke-width': 1 }));
      olcu.appendChild(h('line', { x1: 180, y1: top + 0.5, x2: 188, y2: top + 0.5, stroke: RENK.hi, 'stroke-width': 1 }));
      olcu.appendChild(yazi(192, top + len / 2 + 4, 'boru', { fill: RENK.hi }));
      say.textContent = wc ? wc + ' çizgi' : 'kâğıda değdi';
      msj.textContent = oto ? 'kalkınca uç kendiliğinden ilerledi' : (n >= MAX && !nero) ? 'boru en içte: kaleme bir kez basın' : nero ? 'kalkınca uç kendiliğinden ilerler' : 'uç borunun içinde, boru uçla kayar';
    }
    function cizgi() {
      if (mesgul) return;
      if (n >= MAX && !nero) { tik(0.7); return; }
      n++; wc++; oto = false; var k = (wc - 1) % 6; if (k === 0) bosalt(yazilan);
      yazilan.appendChild(h('line', { x1: 136 - k * 22, y1: kY + 12, x2: 152 - k * 22, y2: kY + 12, stroke: 'rgba(46,47,51,.9)', 'stroke-width': 2.2, 'stroke-linecap': 'round' }));
      goster(); tik(1.5);
      if (nero) { mesgul = true; setTimeout(function () { n = 0; oto = true; goster(); tik(1.1); mesgul = false; }, 420); }
    }
    function bas() { n = 0; oto = false; goster(); tik(0.9); }
    svg.addEventListener('click', cizgi); svg.style.cursor = 'pointer';
    goster();
    st.appendChild(svg);
    st.appendChild(nero ? dugmeSatiri(dugme('Çizgi çek', cizgi)) : dugmeSatiri(dugme('Çizgi çek', cizgi), dugme('Kaleme bas', bas)));
    st.appendChild(notlar(nero ? NOTLAR.nero : NOTLAR.orenz));
  }

  function mekShaker(st) {
    var svg = h('svg', { viewBox: '0 0 320 150', 'class': 'kdm-sema', role: 'img', 'aria-label': 'The Shaker şeması: sallayınca iç ağırlık birleşim yerinden klipse doğru kayar ve ucu ilerletir' });
    var x0 = 12, L = 286, cy = 62, R = 9; function X(f) { return x0 + L * f; }
    var kalem = h('g', { style: 'transition:transform .08s' }); svg.appendChild(kalem);
    [h('rect', { x: X(0), y: cy - R, width: X(0.585) - X(0), height: R * 2, rx: 4, fill: 'none', stroke: RENK.line, 'stroke-width': 1.2 }),
     h('rect', { x: X(0.59), y: cy - R, width: X(0.885) - X(0.59), height: R * 2, rx: 2, fill: 'none', stroke: RENK.line, 'stroke-width': 1.2 }),
     h('rect', { x: X(0.582), y: cy - R - 1.5, width: X(0.594) - X(0.582), height: R * 2 + 3, fill: RENK.line }),
     h('polygon', { points: X(0.885) + ',' + (cy - R) + ' ' + X(0.885) + ',' + (cy + R) + ' ' + X(0.965) + ',' + (cy + 2.4) + ' ' + X(0.965) + ',' + (cy - 2.4), fill: 'none', stroke: RENK.line, 'stroke-width': 1.2 }),
     h('rect', { x: X(0.965), y: cy - 1.2, width: X(0.99) - X(0.965), height: 2.4, fill: RENK.line }),
     h('path', { d: 'M' + X(0.06) + ' ' + (cy - R - 3) + ' L' + X(0.345) + ' ' + (cy - R - 3) + ' L' + X(0.345) + ' ' + (cy - R - 7), fill: 'none', stroke: RENK.line, 'stroke-width': 1.6 })
    ].forEach(function (e) { kalem.appendChild(e); });
    var uc = h('rect', { y: cy - 1, height: 2, fill: RENK.graphite }); kalem.appendChild(uc);
    var ag = h('g', { style: 'transition:transform .22s cubic-bezier(.4,0,.2,1)' }), wx = X(0.49), ww = X(0.58) - X(0.49);
    ag.appendChild(h('rect', { x: wx, y: cy - R + 2.5, width: ww, height: R * 2 - 5, rx: 1.5, fill: RENK.mark, stroke: RENK.ink, 'stroke-width': 1 }));
    for (var i = 1; i < 6; i++) ag.appendChild(h('line', { x1: wx + ww * i / 6, y1: cy - R + 3, x2: wx + ww * i / 6, y2: cy + R - 3, stroke: RENK.ink, 'stroke-width': 0.6 }));
    kalem.appendChild(ag);
    svg.appendChild(yazi(X(0.2), cy - R - 14, 'klips', { anchor: 'middle' }));
    svg.appendChild(yazi(X(0.535), cy + R + 18, 'ağırlık', { anchor: 'middle' }));
    svg.appendChild(yazi(X(0.59), cy + R + 32, 'birleşim yeri', { anchor: 'middle' }));
    svg.appendChild(yazi(X(0.99), cy + R + 18, 'uç', { anchor: 'end' }));
    svg.appendChild(h('line', { x1: X(0.345), y1: cy + R + 52, x2: X(0.58), y2: cy + R + 52, stroke: RENK.hi, 'stroke-width': 1 }));
    svg.appendChild(h('path', { d: 'M' + X(0.345) + ' ' + (cy + R + 52) + ' l6 -3.5 v7 Z M' + X(0.58) + ' ' + (cy + R + 52) + ' l-6 -3.5 v7 Z', fill: RENK.hi }));
    svg.appendChild(yazi(X(0.46), cy + R + 68, 'ağırlığın gidip geldiği yol', { anchor: 'middle', fill: RENK.hi }));
    var say = yazi(12, 16, '', { size: 13, weight: 500 }); svg.appendChild(say);
    var n = 0, mesgul = false;
    function goster() { var ext = Math.min(n, 6) * 2.4; uc.setAttribute('x', X(0.99) - 2); uc.setAttribute('width', 4 + ext); say.textContent = n ? n + ' sallama · uç ' + Math.min(n, 6) + ' adım dışarıda' : 'uç içeride'; }
    function salla() {
      if (mesgul) return; mesgul = true; n++;
      ag.style.transform = 'translateX(' + (X(0.345) - X(0.49)) + 'px)'; kalem.style.transform = 'translateX(-5px)'; tik(1.9);
      setTimeout(function () { ag.style.transform = 'translateX(0)'; kalem.style.transform = 'translateX(4px)'; }, 230);
      setTimeout(function () { kalem.style.transform = 'translateX(0)'; tik(1.2); goster(); mesgul = false; }, 470);
    }
    svg.addEventListener('click', salla); svg.style.cursor = 'pointer';
    goster();
    st.appendChild(svg);
    st.appendChild(dugmeSatiri(dugme('Salla', salla), dugme('Baştan', function () { n = 0; goster(); })));
    st.appendChild(notlar(NOTLAR.shaker));
  }

  /* ---------- ağırlık çizimleri ---------- */
  function siluet(g, x0, y, p, k, dolgu) {
    var L = p.L * k, Rr = Math.max(3, (p.D || 9) * k / 2), koni = 12 * k, kilavuz = 4 * k;
    g.appendChild(h('rect', { x: x0, y: y - Rr, width: L - koni - kilavuz, height: Rr * 2, rx: Math.min(4, Rr), fill: dolgu, stroke: RENK.ink, 'stroke-width': 1 }));
    g.appendChild(h('polygon', { points: (x0 + L - koni - kilavuz) + ',' + (y - Rr) + ' ' + (x0 + L - koni - kilavuz) + ',' + (y + Rr) + ' ' + (x0 + L - kilavuz) + ',' + (y + 1.6) + ' ' + (x0 + L - kilavuz) + ',' + (y - 1.6), fill: dolgu, stroke: RENK.ink, 'stroke-width': 1 }));
    g.appendChild(h('rect', { x: x0 + L - kilavuz, y: y - 0.8, width: kilavuz, height: 1.6, fill: RENK.ink }));
  }
  function paralar(g, x0, y, n, rr) {
    var tam = Math.floor(n), kes = n - tam;
    for (var i = 0; i < tam; i++) { var cx = x0 + rr + i * (rr * 1.45); g.appendChild(h('circle', { cx: cx, cy: y, r: rr, fill: '#d8c27a', stroke: RENK.ink, 'stroke-width': 1 })); g.appendChild(h('circle', { cx: cx, cy: y, r: rr * 0.66, fill: '#c4c9cc', stroke: RENK.ink, 'stroke-width': 0.6 })); g.appendChild(yazi(cx, y + 4, '1', { anchor: 'middle', size: 12, weight: 500 })); }
    if (kes > 0.04) {
      var c2 = x0 + rr + tam * (rr * 1.45), e = kutup(c2, y, rr, kes * 360 - 0.01);
      g.appendChild(h('circle', { cx: c2, cy: y, r: rr, fill: 'none', stroke: RENK.ink, 'stroke-width': 1, 'stroke-dasharray': '3 3' }));
      g.appendChild(h('path', { d: 'M' + c2 + ' ' + y + ' L' + c2 + ' ' + (y - rr) + ' A' + rr + ' ' + rr + ' 0 ' + (kes > 0.5 ? 1 : 0) + ' 1 ' + e[0] + ' ' + e[1] + ' Z', fill: '#d8c27a', stroke: RENK.ink, 'stroke-width': 1 }));
    }
  }
  function urunKarti(b, alt, url) {
    var c = h('div', { 'class': 'kdm-kart' }, h('b', null, b), h('span', null, alt));
    if (url) c.appendChild(h('a', { href: url }, 'Ürüne git'));
    return c;
  }

  /* ---------- kurulum: Rehberler'deki merkez ---------- */
  var MEKLER = [
    { k: 'kt', ad: 'Kuru Toga' },
    { k: 'orenz', ad: 'Orenz' },
    { k: 'nero', ad: 'Orenz Nero' },
    { k: 'shaker', ad: 'The Shaker' }
  ];
  function tl(kurus) { try { return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(kurus / 100) + ' TL'; } catch (e) { return (kurus / 100) + ' TL'; } }
  function ucBul(metin) { var m = String(metin || '').replace(/,/g, '.').match(/0\.[23579]/); return m ? m[0] : ''; }

  function masa(kap, U, V) {
    var mm = parseFloat(U.mm), olcek = S;
    var kayitli = parseFloat(oku('kls-dm-olcek', '')); if (kayitli > 3 && kayitli < 14) olcek = kayitli;
    function olc() { return olcek; }
    var sekmeAd = ['Yazı', 'Mekanizma', 'Ağırlık'], panel = [];
    var ust = h('div', { 'class': 'kdm-ust' }), sekmeler = h('div', { 'class': 'kdm-sekmeler', role: 'tablist' });
    var sesB = h('button', { 'class': 'kdm-ses', type: 'button', 'aria-pressed': String(ses.on), 'aria-label': 'Arayüz sesi' }, 'ses');
    sesB.addEventListener('click', function () { ses.on = !ses.on; yaz('kls-dm-ses', ses.on ? '1' : '0'); sesB.setAttribute('aria-pressed', String(ses.on)); if (ses.on) tik(); });
    var btns = sekmeAd.map(function (ad, i) {
      var p = h('div', { 'class': 'kdm-panel', role: 'tabpanel' }); p.hidden = i !== 0; panel.push(p);
      return h('button', { 'class': 'kdm-sekme', type: 'button', role: 'tab', 'aria-selected': i === 0 ? 'true' : 'false', on: { click: function () { sec(i); } } }, ad);
    });
    function sec(i) { btns.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); }); panel.forEach(function (p, j) { p.hidden = j !== i; }); tik(1.25); }
    btns.forEach(function (b) { sekmeler.appendChild(b); });
    ust.appendChild(sekmeler); ust.appendChild(sesB);
    kap.appendChild(ust); panel.forEach(function (p) { kap.appendChild(p); });

    /* yazı */
    var pY = panel[0];
    var iF = -1; UCLAR.forEach(function (u, i) { if (u.mm === mm) iF = i; });
    var basla = iF >= 0 ? iF : 2;
    var buyuk = h('span', { 'class': 'kdm-buyuk' }), alt = h('span', { 'class': 'kdm-mini' });
    pY.appendChild(h('div', { 'class': 'kdm-okuma' }, buyuk, alt));
    var kagit = Kagit(pY, { mm: UCLAR[basla].w, olcek: olc });
    var iz = h('p', { 'class': 'kdm-iz' }), kart = h('div');
    var sira = Sira(pY, { w: UCLAR.map(function (u) { return u.w; }), olcek: olc });
    var once = null, simdi = basla, uclarVeri = {};
    (V.uclar || []).forEach(function (u) { uclarVeri[u.mm] = u.urun; });
    Kapsul(pY, {
      aria: 'Uç kalınlığı', deger: basla, igne: iF >= 0 ? { pos: iF / (UCLAR.length - 1), label: 'seçili kalem' } : null,
      duraklar: UCLAR.map(function (u, i) { return { pos: i / (UCLAR.length - 1), label: tr(u.mm), balon: tr(u.mm) + ' mm' }; }),
      degisti: function (i) {
        var u = UCLAR[i]; if (i !== simdi) once = simdi; simdi = i; kagit.set(u.w);
        buyuk.textContent = tr(u.mm) + ' mm'; alt.textContent = 'gerçek çap ' + u.jis + ' mm';
        iz.textContent = once != null && once !== i ? 'Arkadaki açık gri iz ' + tr(UCLAR[once].mm) + ' mm.' : '';
        bosalt(kart);
        var ur = uclarVeri[String(u.mm)];
        if (i === iF) kart.appendChild(urunKarti('Seçili kalemin kalınlığı', tr(u.mm) + ' mm'));
        else if (ur && ur.handle !== U.handle) kart.appendChild(urunKarti(ur.ad, tr(u.mm) + ' mm · ' + tl(ur.kurus), ur.url));
        else kart.appendChild(urunKarti(tr(u.mm) + ' mm', 'Bu kalınlıkta şu an stokta versatil kalem yok'));
      }
    });
    var not = h('p', { 'class': 'kdm-mini kdm-soluk' });
    var ayarB = h('button', { 'class': 'kdm-btn', type: 'button' }, 'Gerçek boyuta ayarla');
    var geriB = h('button', { 'class': 'kdm-btn', type: 'button' }, 'Büyütülmüş görünüm');
    var para = h('div', { 'class': 'kdm-para' }, '1 TL');
    var aralik = h('input', { type: 'range', min: '70', max: '260', step: '1', 'aria-label': 'Daire çapı' });
    var tamamB = h('button', { 'class': 'kdm-btn', type: 'button' }, 'Tamam'), vazB = h('button', { 'class': 'kdm-btn', type: 'button' }, 'Vazgeç');
    var ayar = h('div', { 'class': 'kdm-ayar' }, h('p', null, '1 TL\'yi ekrana yatırın. Kesik çizgili daire paranın kenarına denk gelene kadar kaydırın.'), para, aralik, dugmeSatiri(tamamB, vazB));
    ayar.hidden = true;
    function paraBoyu() { para.style.width = para.style.height = aralik.value + 'px'; }
    function tazele() {
      kagit.ciz(); sira.ciz(); var acik = olcek !== S;
      not.textContent = acik ? 'Gerçek boyut: 1 TL ile ayarlandı (1 mm = ' + tr(olcek, 1) + ' piksel). Çizgiler kâğıttaki genişliğinde.' : 'Büyütülmüş: 1 mm = 8 piksel, telefonda gerçeğin yaklaşık 1,3 katı. Gerçek boyut için 1 TL ile ayarlayın.';
      geriB.hidden = !acik; ayarB.textContent = acik ? 'Yeniden ayarla' : 'Gerçek boyuta ayarla';
    }
    ayarB.addEventListener('click', function () { aralik.value = String(Math.round(PARA.d * olcek)); paraBoyu(); ayar.hidden = false; ayarB.hidden = true; tik(); });
    aralik.addEventListener('input', paraBoyu);
    tamamB.addEventListener('click', function () { olcek = Number(aralik.value) / PARA.d; yaz('kls-dm-olcek', String(olcek)); ayar.hidden = true; ayarB.hidden = false; tazele(); tik(1.3); });
    vazB.addEventListener('click', function () { ayar.hidden = true; ayarB.hidden = false; });
    geriB.addEventListener('click', function () { olcek = S; yaz('kls-dm-olcek', null); tazele(); tik(0.9); });
    pY.appendChild(iz); pY.appendChild(kart); pY.appendChild(dugmeSatiri(ayarB, geriB)); pY.appendChild(ayar); pY.appendChild(not);
    pY.appendChild(h('p', { 'class': 'kdm-mini kdm-soluk' }, 'Çizgi, ucun standarttaki gerçek çapıyla (JIS S 6005) çizildi. Doku benzetim; kâğıttaki koyuluk uç sertliğine, kâğıda ve bastırmaya göre değişir.'));
    tazele();

    /* mekanizma: dört mekanizma, seçili kalemin mekanizması işaretli */
    var pM = panel[1], mekler = MEKLER.map(function (m) { return (m.k === 'kt' && U.mek === 'kt2') ? { k: 'kt2', ad: 'Kuru Toga' } : m; });
    var iM = -1; mekler.forEach(function (m, i) { if (m.k === U.mek) iM = i; });
    var sahne = h('div', { 'class': 'kdm-mek' }), mekBag = h('div');
    Kapsul(pM, {
      aria: 'Mekanizma', deger: iM >= 0 ? iM : 0, igne: iM >= 0 ? { pos: iM / (mekler.length - 1), label: 'seçili kalem' } : null,
      duraklar: mekler.map(function (m, i) { return { pos: i / (mekler.length - 1), label: m.ad }; }),
      degisti: function (i) {
        var m = mekler[i]; bosalt(sahne); bosalt(mekBag);
        if (m.k === 'kt' || m.k === 'kt2') mekKT(sahne, m.k);
        else if (m.k === 'orenz') mekOrenz(sahne, false);
        else if (m.k === 'nero') mekOrenz(sahne, true);
        else mekShaker(sahne);
        var t = (V.temsilci || {})[m.k];
        if (m.k === U.mek) mekBag.appendChild(urunKarti('Seçili kalem bu mekanizmayla çalışır', U.ad));
        else if (t) mekBag.appendChild(urunKarti('Bu mekanizmalı bir kalem', t.ad, t.url));
      }
    });
    pM.appendChild(sahne); pM.appendChild(mekBag);

    /* ağırlık */
    var pA = panel[2];
    var kalemler = (V.kalemler || []).filter(function (p) { return p.g && p.L; }).slice();
    var ben = null; kalemler.forEach(function (p) { if (p.handle === U.handle) ben = p; });
    kalemler.sort(function (a, b) { return a.g - b.g; });
    if (!kalemler.length) { pA.appendChild(h('p', { 'class': 'kdm-mini' }, 'Ağırlık verisi yok.')); return; }
    var gmin = Math.floor(kalemler[0].g / 5) * 5, gmax = Math.max(gmin + 5, Math.ceil(kalemler[kalemler.length - 1].g / 5) * 5);
    var pos = function (g) { return (g - gmin) / (gmax - gmin); };
    var cent = []; for (var g5 = gmin; g5 <= gmax; g5 += 5) cent.push({ pos: pos(g5), label: g5 + ' g' });
    var ad = h('div', { 'class': 'kdm-ad' }), gr = h('div', { 'class': 'kdm-buyuk' });
    var svg = h('svg', { viewBox: '0 0 320 168', 'class': 'kdm-sema', role: 'img', 'aria-label': 'Kalemlerin boy ve ağırlık kıyası' });
    var yaziA = h('p', { 'class': 'kdm-mini' }), bag = h('div');
    if (!ben) pA.appendChild(h('p', { 'class': 'kdm-iz' }, 'Seçili kalemin ağırlık ölçüsü yok; ölçüsü bilinen kalemleri kıyaslayabilirsiniz.'));
    pA.appendChild(h('div', { 'class': 'kdm-satir' }, ad, gr)); pA.appendChild(svg); pA.appendChild(yaziA);
    var kap2 = Kapsul(pA, {
      aria: 'Kıyaslanacak kalem', etiket: false, olcek: cent, igne: ben ? { pos: pos(ben.g), label: 'seçili kalem' } : null, deger: ben ? kalemler.indexOf(ben) : 0,
      duraklar: kalemler.map(function (p) { return { pos: pos(p.g), label: p.kisa + ' ' + tr(p.g) + ' g', balon: p.kisa }; }),
      degisti: function (i) {
        var p = kalemler[i], ayni = !ben || p === ben, ref = ben || p;
        ad.textContent = p.kisa; gr.textContent = tr(p.g) + ' g';
        bosalt(svg); svg.setAttribute('viewBox', ayni ? '0 0 320 132' : '0 0 320 168'); var k = 1.75, gg = h('g'); svg.appendChild(gg);
        gg.appendChild(yazi(10, 14, ayni ? p.kisa : 'seçili: ' + ref.kisa, { fill: RENK.muted }));
        siluet(gg, 10, 30, ref, k, '#fac8cd');
        if (!ayni) { gg.appendChild(yazi(10, 58, p.kisa, { fill: RENK.muted })); siluet(gg, 10, 74, p, k, '#ffffff'); }
        gg.appendChild(yazi(10, ayni ? 60 : 102, 'boy ' + tr(p.L) + ' mm' + (p.D ? ' · çap ' + tr(p.D) + ' mm' : '')));
        var n = p.g / PARA.g; paralar(gg, 10, ayni ? 104 : 140, n, PARA.d * k / 2);
        var d = p.g - ref.g;
        yaziA.textContent = (ayni ? '' : 'Seçili kalemden ' + tr(Math.abs(d), 1) + ' g daha ' + (d > 0 ? 'ağır. ' : 'hafif. ')) + '≈ ' + tr(n, 1) + ' tane 1 TL (8,2 g) ağırlığında; kalemler ve para aynı ölçekte.' + (p.kaynak ? ' Ölçü: ' + p.kaynak + '.' : '');
        bosalt(bag); if (p !== ben && p.url) bag.appendChild(h('a', { 'class': 'kdm-git', href: p.url }, p.kisa + ' ürün sayfası'));
      }
    });
    pA.appendChild(h('div', { 'class': 'kdm-satir' }, bag, dugmeSatiri(
      h('button', { 'class': 'kdm-btn', type: 'button', 'aria-label': 'Daha hafif kalem', on: { click: function () { kap2.set(kap2.get() - 1); } } }, '‹'),
      h('button', { 'class': 'kdm-btn', type: 'button', 'aria-label': 'Daha ağır kalem', on: { click: function () { kap2.set(kap2.get() + 1); } } }, '›'))));
  }

  function merkez(el) {
    var govde = el.querySelector('[data-kdm-govde]'), veriEl = el.querySelector('[data-kdm-veri]');
    if (!govde || !veriEl || govde.getAttribute('data-kuruldu')) return;
    var V; try { V = JSON.parse(veriEl.textContent); } catch (e) { return; }
    govde.setAttribute('data-kuruldu', '1'); bosalt(govde);
    var kalemler = (V.kalemler || []).slice();
    function mekBul(handle) { var b = ''; Object.keys(V.listeler || {}).forEach(function (k) { if ((V.listeler[k] || []).indexOf(handle) >= 0) b = k; }); return b; }
    var secici = h('div', { 'class': 'kdm-secici', role: 'group', 'aria-label': 'Kalem seç' });
    var secili = h('div'), masaKap = h('div', { 'class': 'kdm-masa' });
    govde.appendChild(h('p', { 'class': 'kdm-secici-baslik' }, 'Hangi kalem?'));
    govde.appendChild(secici); govde.appendChild(secili); govde.appendChild(masaKap);
    var cipler = [];
    function cipCiz() {
      bosalt(secici); cipler = kalemler.map(function (p) {
        var b = h('button', { 'class': 'kdm-cip', type: 'button', 'aria-pressed': 'false' }, p.kisa);
        b.addEventListener('click', function () { sec(p, true); }); secici.appendChild(b); return b;
      });
    }
    function sec(p, sesli) {
      cipler.forEach(function (b, i) { b.setAttribute('aria-pressed', kalemler[i] === p ? 'true' : 'false'); });
      bosalt(secili); secili.appendChild(urunKarti(p.ad, (p.mm ? tr(parseFloat(p.mm)) + ' mm · ' : '') + (p.kurus != null ? tl(p.kurus) : ''), p.url));
      var sb = cipler[kalemler.indexOf(p)]; if (sb) secici.scrollLeft = Math.max(0, sb.getBoundingClientRect().left - secici.getBoundingClientRect().left + secici.scrollLeft - 16);
      bosalt(masaKap); masa(masaKap, p, V);
      try { var u = new URL(location.href); u.searchParams.set('kalem', p.handle); history.replaceState(null, '', u.pathname + u.search); } catch (e) {}
      if (sesli) tik();
    }
    var istenen = null; try { istenen = new URLSearchParams(location.search).get('kalem'); } catch (e) {}
    var varsayilan = kalemler.filter(function (p) { return p.mek === 'kt'; })[0] || kalemler[0];
    var bulunan = istenen ? kalemler.filter(function (p) { return p.handle === istenen; })[0] : null;
    cipCiz();
    if (bulunan || !istenen) { if (varsayilan || bulunan) sec(bulunan || varsayilan); return; }
    /* listede olmayan kalem: Shopify ürün verisinden kur */
    fetch('/products/' + encodeURIComponent(istenen) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || String(j.type || '').toLowerCase().indexOf('versatil') < 0) { if (varsayilan) sec(varsayilan); return; }
      var v = (j.variants || []).filter(function (x) { return x.available; })[0] || (j.variants || [])[0] || {};
      var p = { handle: j.handle, ad: j.title, kisa: 'Bu kalem', mm: ucBul(v.title) || ucBul(j.title), mek: mekBul(j.handle), g: null, L: null, D: null, url: j.url || ('/products/' + j.handle), kurus: j.price };
      kalemler.unshift(p); cipCiz(); sec(p);
    }).catch(function () { if (varsayilan) sec(varsayilan); });
  }

  window.KLSDM = { merkez: merkez };
})();
